import { observer } from 'mobx-react-lite';

import usePresenter from './presenter';

const ThreadCounterHandler = () => {
  usePresenter();

  return null;
};

export default observer(ThreadCounterHandler);
